/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormRadio64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormRadio64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M43 32C43 38.0751 38.0751 43 32 43C25.9249 43 21 38.0751 21 32C21 25.9249 25.9249 21 32 21C38.0751 21 43 25.9249 43 32Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 42C37.5228 42 42 37.5228 42 32C42 26.4772 37.5228 22 32 22C26.4772 22 22 26.4772 22 32C22 37.5228 26.4772 42 32 42ZM32 43C38.0751 43 43 38.0751 43 32C43 25.9249 38.0751 21 32 21C25.9249 21 21 25.9249 21 32C21 38.0751 25.9249 43 32 43Z"
            fill="currentColor"
          />
          <circle cx="32" cy="32" r="5" fill="white" />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormRadio64Icon.tags = [
  'radio',
  'select',
  'button',
  'option',
  'circle',
];

AddPanelFormRadio64Icon.category = '64x64 (Add panel)';

AddPanelFormRadio64Icon.iconSize = 64;
